import i18n from "utils/i18n";

import MD5 from "crypto-js/md5";

export const  md5 = (value) => {
  return MD5(value).toString();
}

export const dateFormater = (date) => {
    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0'); 
    const day = String(dateObj.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
}

export const formatPrice = (price) => {
	const formatter = new Intl.NumberFormat("fr-FR", {
		style: "currency",
		currency: "DZD",
		minimumFractionDigits: 2,
	});
	return formatter
		.format(price)
		.replace("DZD", i18n.t("DA")) 
		.replace(/\s/g, " ") 
		.replace(",", ".");
};


export const capitalizeFirstLetter = (str) => {
    if (!str || typeof str !== 'string') {
        return str;
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function formatTime(input){
    if (!input) {
        return "";
    }
    const [hours, minutes] = input.replace(/\s/g, '').split(':').map(Number);

    if (hours === 0) {
      return `${minutes} ${i18n.t("mins")}`;
    }

    return `${hours} ${i18n.t("hours")} ${minutes} ${i18n.t("mins")}`;
}

export const flipDate = (date) => {
    const [day, month, year] = date.split('-');
    return `${year}-${month}-${day}`;
}

export const  dayFromDate = (date) => {
    const dateObj = new Date(date);
    const options = { weekday: 'long' };
    return dateObj.toLocaleDateString('en-US', options);
}

export function formatDate2(input, langauge = "en") {
    if (!input) {
        return "";
    }
    const [day, month, year] = input.split('-').map(Number);

    if (!day || !month || !year) {
        return "Invalid date format";
    }
    const date = new Date(year, month - 1, day); 

    if (isNaN(date.getTime())) {
        return "Invalid date";
    }
    const lang = langauge === "en" ? "en-US" : langauge === "ar" ? "ar-DZ" : "fr-FR";
    const monthName = date.toLocaleDateString(lang, { month: 'short' });
    const dayNum = date.getDate();

    return `${dayNum} ${monthName}`;
}

export const pixelEvent = (value , currency) => {
    if(window.fbq){
    console.log('Tracking pixel event' , window , value , currency);
    window.fbq('track', 'Purchase', {
        value: value,
        currency: currency
    });
    }
}